var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "text-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Metin Ayarları - " + _vm.widget.title,
        width: "90%",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("a-form", { attrs: { form: _vm.form, layout: "vertical" } }, [
        _c("div", { staticClass: "editor-container" }, [
          _c("div", { staticClass: "editor-toolbar" }, [
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.bold") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("bold")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().toggleBold().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_bold"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.italic") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("italic")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().toggleItalic().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_italic"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.underline") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("underline")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().toggleUnderline().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_underlined"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.strikethrough") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("strike")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().toggleStrike().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_strikethrough"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.textColor") } },
                  [
                    _c("a-button", { staticClass: "color-button" }, [
                      _c("input", {
                        staticClass: "color-input",
                        attrs: { type: "color" },
                        on: {
                          change: function (e) {
                            return (
                              _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .setColor(e.target.value)
                                .run()
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("format_color_text"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.heading1") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor &&
                            _vm.editor.isActive("heading", { level: 1 })
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 1 })
                                .run()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("table.textEditorH1")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.heading2") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor &&
                            _vm.editor.isActive("heading", { level: 2 })
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 2 })
                                .run()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("table.textEditorH2")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.heading3") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor &&
                            _vm.editor.isActive("heading", { level: 3 })
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 3 })
                                .run()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("table.textEditorH3")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.bulletList") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("bulletList")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleBulletList()
                                .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_list_bulleted"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.numberedList") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("orderedList")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleOrderedList()
                                .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_list_numbered"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.quote") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("blockquote")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .toggleBlockquote()
                                .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_quote"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.codeBlock") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.editor && _vm.editor.isActive("codeBlock")
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().toggleCodeBlock().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("code"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.horizontalLine") } },
                  [
                    _c(
                      "a-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor
                                .chain()
                                .focus()
                                .setHorizontalRule()
                                .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("remove"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.alignLeft") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.$_.get(_vm.previewSettings, "textAlign") ===
                            "left"
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$_.set(
                              _vm.previewSettings,
                              "textAlign",
                              "left"
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_align_left"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.alignCenter") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.$_.get(_vm.previewSettings, "textAlign") ===
                            "center"
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$_.set(
                              _vm.previewSettings,
                              "textAlign",
                              "center"
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_align_center"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.alignRight") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.$_.get(_vm.previewSettings, "textAlign") ===
                            "right"
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$_.set(
                              _vm.previewSettings,
                              "textAlign",
                              "right"
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_align_right"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.alignJustify") } },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type:
                            _vm.$_.get(_vm.previewSettings, "textAlign") ===
                            "justify"
                              ? "primary"
                              : "default",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$_.set(
                              _vm.previewSettings,
                              "textAlign",
                              "justify"
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("format_align_justify"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.undo") } },
                  [
                    _c(
                      "a-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().undo().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("undo"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: _vm.$t("table.redo") } },
                  [
                    _c(
                      "a-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editor &&
                              _vm.editor.chain().focus().redo().run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("redo"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "editor-content" },
            [_c("editor-content", { attrs: { editor: _vm.editor } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "appearance-settings" },
          [
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("table.backgroundColor") } },
              [
                _c("a-input", {
                  attrs: { type: "color" },
                  model: {
                    value: _vm.previewSettings.backgroundColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.previewSettings, "backgroundColor", $$v)
                    },
                    expression: "previewSettings.backgroundColor",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-item",
              { attrs: { label: _vm.$t("table.paddingPx") } },
              [
                _c("a-slider", {
                  attrs: { min: 0, max: 48, step: 4 },
                  model: {
                    value: _vm.previewSettings.padding,
                    callback: function ($$v) {
                      _vm.$set(_vm.previewSettings, "padding", $$v)
                    },
                    expression: "previewSettings.padding",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "a-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("table.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.saving },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("table.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }